// Author thq
// Date 2023-09-06 00:11:44

class TpmMonitorProgramStatusTmp {
    constructor({
                    id = null,
                    tmpCodeBda = '',
                    tmpIdIesmrs = '',
                    tmpBeginTime = '',
                    tmpEndTime = '',
                    tmpDurationTime = '',
                    tmpStartValue = '',
                    tmpEndValue = '',
                    pwrId = '',
                    pwrOrderCode = '',
                    pwrOperateSeqId = '',
                    pwrOperateSeq = '',
                    pwrActLocationId = '',
                    pwrActLocationName = '',
                    pwrStartTime = '',
                    pwrEndTime = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.tmpCodeBda = tmpCodeBda;
        this.tmpIdIesmrs = tmpIdIesmrs;
        this.tmpBeginTime = tmpBeginTime;
        this.tmpEndTime = tmpEndTime;
        this.tmpDurationTime = tmpDurationTime;
        this.tmpStartValue = tmpStartValue;
        this.tmpEndValue = tmpEndValue;
        this.pwrId = pwrId;
        this.pwrOrderCode = pwrOrderCode;
        this.pwrOperateSeqId = pwrOperateSeqId;
        this.pwrOperateSeq = pwrOperateSeq;
        this.pwrActLocationId = pwrActLocationId;
        this.pwrActLocationName = pwrActLocationName;
        this.pwrStartTime = pwrStartTime;
        this.pwrEndTime = pwrEndTime;
        this.remark = remark;
    }
}

function newEntity() {
    return new TpmMonitorProgramStatusTmp();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'nodeId',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.grid.nodeId',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmpCodeBda',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.grid.tmpCodeBda',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmpIdIesmrs',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.grid.tmpIdIesmrs',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'iesmrs',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.grid.iesmrs',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmpBeginTime',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.grid.tmpBeginTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmpEndTime',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.grid.tmpEndTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmpDurationTime',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.grid.tmpDurationTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmpStartValue',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.grid.tmpStartValue',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmpEndValue',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.grid.tmpEndValue',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        // {
        // key: 'pwrStartTime',
        // label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.grid.pwrStartTime',
        // sortable: true,
        // form: {
        // type: 'datetimepicker',
        // modalMultiSelectedType: 'string'
        //                 }
        // },
        // {
        // key: 'pwrEndTime',
        // label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.grid.pwrEndTime',
        // sortable: true,
        // form: {
        // type: 'datetimepicker',
        // modalMultiSelectedType: 'string'
        //                 }
        // },
        {
            key: 'remark',
            label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    nodeIdFilter: '',
    tmpCodeBdaFilter: '',
    tmpIdIesmrsFilter: '',
    iesmrsFilter: '',
    tmpBeginTimeRteFilter: '',
    tmpBeginTimeLteFilter: '',
    tmpEndTimeRteFilter: '',
    tmpEndTimeLteFilter: '',
    tmpEndTimeIsNullFilter: '',
    tmpDurationTimeFilter: '',
    tmpStartValueFilter: '',
    tmpEndValueFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'nodeIdFilter',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.filter.nodeId',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmpCodeBdaFilter',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.filter.tmpCodeBda',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmpBeginTimeRteFilter',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.filter.tmpBeginTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmpBeginTimeLteFilter',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.filter.tmpBeginTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmpEndTimeRteFilter',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.filter.tmpEndTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmpEndTimeLteFilter',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.filter.tmpEndTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
];


const entityFormConfigs = [
    {
        key: 'tmpCodeBda',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.entity.tmpCodeBda',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmpIdIesmrs',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.entity.tmpIdIesmrs',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmpBeginTime',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.entity.tmpBeginTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmpEndTime',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.entity.tmpEndTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmpDurationTime',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.entity.tmpDurationTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pwrStartTime',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.entity.pwrStartTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pwrEndTime',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.entity.pwrEndTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.em.statusCollection.tpmMonitorProgramStatusTmp.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    TpmMonitorProgramStatusTmp, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
